import {string} from "../general-purpose-parsers";

export const parseExpressionUserInput = string;
